import { Tab, Tabs, styled } from "@mui/material";

import { TRADE_HISTORY_TABS } from "../constants";
import { useSearchParams } from "react-router-dom";

function TradeHistoryTabs() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tradeTab = +searchParams.get("tradeTab") || 0;

  const handleChange = (_, value) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      tradeTab: value,
    });
  };

  return (
    <TabsStyle value={tradeTab} onChange={handleChange}>
      {Object.values(TRADE_HISTORY_TABS)?.map((tab) => (
        <Tab value={tab.value} label={tab.name} key={tab.key} />
      ))}
    </TabsStyle>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default TradeHistoryTabs;
